const API = 'RatingMatrixDocument';
const APIHelper = 'RatingMatrixDocumentHelper';

export const API_RATING_MATRIX_DOCUMENT = {
  API,
  APIHelper,
  
  GET_ALL_DYNAMIC: `${API}/GetAllDynamic`,
  EXPORT_RATING_MATRIX: `${APIHelper}/ExportRatingMatrix`,
};

export enum eRatingMatrixDocumentSteps {
  Sync = 1,
  ExportRating = 2,
  ExportOutlook = 3,
  ExportSector = 4, 
  Done = 5,
}

export type tRatingMatrixDocument = {
  id: number;
  createdDate: string;
  updatedDate: string;
  title: string;
  ratingPerformanceCategoryID: number;
  step: eRatingMatrixDocumentSteps;
  exportDate: string | null;
  ratingsExcel: string;
  outlooksExcel: string;
  sectorExcel: string;
  ratingPerformanceCategory: any | null;
};
